<h2 mat-dialog-title>Add Contributor</h2>
<mat-dialog-content>
  <form id="map-contrib-form" [formGroup]="contributorForm" (ngSubmit)="submit()">
    <p>
      <mat-form-field appearance="outline">
        <mat-label>Name</mat-label>
        <input matInput [formControl]="name" />
      </mat-form-field>
    </p>

    <p>
      <mat-form-field appearance="outline">
        <mat-label>Email</mat-label>
        <input matInput type="email" [formControl]="email" />
      </mat-form-field>
    </p>

    <p>
      <mat-form-field appearance="outline">
        <mat-label>Role</mat-label>
        <mat-select multiple [formControl]="roles">
          @for (role of contributorRoles | keyvalue; track role.key) {
            <mat-option value="{{ role.value }}">{{ role.key }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </p>

    <mat-dialog-actions align="end">
      <button
        mat-flat-button
        type="submit"
        [disabled]="contributorForm.pristine || !contributorForm.valid"
      >
        Save
      </button>
      <button mat-button type="button" (click)="cancel()">Cancel</button>
    </mat-dialog-actions>
  </form>
</mat-dialog-content>
